module.exports = __webpack_public_path__ + "static/img/imgdata.8687db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/imgdata.png
// module id = /hsO
// module chunks = 51